import { useTranslation } from "react-i18next";
import logoHeader from "../../assets/images/symmio-logos/symmio-logo-text-white-side-large.png"
import moment from "moment";

const COMPONENT_CLASS = "c-report";

interface ReportDateRangeHeaderProps {
    companyName?: string;
    reportName: string;
    startDate: string;
}

const ReportDateRangeHeader: React.FC<ReportDateRangeHeaderProps> = (props: ReportDateRangeHeaderProps) => {
    const { companyName, reportName, startDate } = props;
    const today = moment();
    const start = moment(startDate);

    // Format start date based on year comparison
    const formattedStartDate = start.year() === today.year()
        ? start.format("MMMM DD")       // Different year: "June 24"
        : start.format("MMMM DD, yyyy");  // Same year: "June 24, 2025"

    const todayDate = today.format("MMMM DD, yyyy");

    const { t } = useTranslation();

    return (
        <div className={`${COMPONENT_CLASS}__header__wellness`}>
            <div className={`${COMPONENT_CLASS}__logo`}>
                <img src={logoHeader} alt="Symmio Logo" />
            </div>
            <div>
                <div className="text-sm font-light text-right">{reportName}</div>
                <div className="text-xs font-light text-right" style={{ color: "rgba(173, 223, 253, 1)" }}>
                    {companyName || t('reports.noCompanyName')} • {formattedStartDate} - {todayDate}
                </div>
            </div>
        </div>
    );
}

export default ReportDateRangeHeader;